import { createEvent } from 'ics';
import { API_ORIGIN } from './api';
import { addDays, dayKey, noteCalendarDate, noteTextParts, parseDay } from './calendarDates';

const utcParts = date => [date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds()];
const compactUtc = date => date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z');
const EXPORT_MINUTES = 60;

export function calendarEventAttributes(note) {
  const placement = noteCalendarDate(note);
  if (!note?.id || !placement) throw new Error('Choose a date before adding this item to a calendar.');
  const parts = noteTextParts(note.text);
  const common = {
    uid: `${note.id}@${new URL(API_ORIGIN).hostname}`,
    title: parts.title || 'Tap Talk Save',
    description: parts.notes || note.text,
    categories: note.category ? [note.category] : [],
    productId: 'Tap Talk Save',
  };
  if (placement.timed) {
    return { ...common, start: utcParts(placement.date), end: utcParts(new Date(placement.date.getTime() + EXPORT_MINUTES * 60000)), startInputType: 'utc', startOutputType: 'utc', endInputType: 'utc', endOutputType: 'utc' };
  }
  return { ...common, start: placement.day.split('-').map(Number), end: dayKey(addDays(parseDay(placement.day), 1)).split('-').map(Number) };
}

export function calendarFile(note) {
  const { error, value } = createEvent(calendarEventAttributes(note));
  if (error || !value) throw new Error('Could not prepare this calendar file. Please try again.');
  return value;
}

export function downloadCalendarFile(note) {
  // Synchronous generation/click stays in the user's gesture for Safari.
  const value = calendarFile(note);
  const url = URL.createObjectURL(new Blob([value], { type: 'text/calendar;charset=utf-8' }));
  const link = document.createElement('a');
  const title = noteTextParts(note.text).title.replace(/[^a-z0-9_-]+/gi, '-').replace(/^-+|-+$/g, '').slice(0, 70) || 'tap-talk-save';
  link.href = url; link.download = `${title}.ics`; link.rel = 'noopener';
  document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export function googleCalendarLink(note) {
  const placement = noteCalendarDate(note);
  if (!placement) return null;
  const endpoint = process.env.REACT_APP_GOOGLE_CALENDAR_URL;
  if (!endpoint) throw new Error('Google Calendar export is not configured.');
  const url = new URL(endpoint), parts = noteTextParts(note.text);
  url.searchParams.set('action', 'TEMPLATE'); url.searchParams.set('text', parts.title || 'Tap Talk Save');
  url.searchParams.set('details', parts.notes || note.text);
  const dates = placement.timed ? `${compactUtc(placement.date)}/${compactUtc(new Date(placement.date.getTime() + EXPORT_MINUTES * 60000))}` : `${placement.day.replace(/-/g, '')}/${dayKey(addDays(parseDay(placement.day), 1)).replace(/-/g, '')}`;
  url.searchParams.set('dates', dates);
  // Never truncate someone's notes to squeeze them into a provider URL.
  return url.href.length <= 7500 ? url.href : null;
}